module.exports = __webpack_public_path__ + "static/media/seamstress-we-facilitate.096ec249.jpg";